// extracted by mini-css-extract-plugin
export var accordionItemStyle = "search_jobs_result_accordion_wrapper-module--accordionItemStyle--F-tH3";
export var chevronStyle = "search_jobs_result_accordion_wrapper-module--chevronStyle--GK0oQ";
export var contentStyle = "search_jobs_result_accordion_wrapper-module--contentStyle--lmxY1";
export var headingStyle = "search_jobs_result_accordion_wrapper-module--headingStyle--M0TvC";
export var iconStyle = "search_jobs_result_accordion_wrapper-module--iconStyle--5R2mn";
export var isActiveStyle = "search_jobs_result_accordion_wrapper-module--isActiveStyle--kQ+Ur";
export var jobListStyle = "search_jobs_result_accordion_wrapper-module--jobListStyle--lgv5u";
export var wrapperStyle = "search_jobs_result_accordion_wrapper-module--wrapperStyle--2EPTV";